// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  save: `save`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  dashboard: `Dashboard`,
  auth: {
    logout: 'Logout',
    tech_support: 'Tech Support',
  },
  banners: {
    practicum: {
      title: 'Practicum',
      description: 'Training materials and practical assignments for effective work.',
      button: 'Go to',
    },
    news: {
      title: 'News',
      description: 'Latest updates, news, and important announcements.',
      button: 'Read',
    },
  },
  companies: {
    name_company: `Shop Name`,
    edit_shop: `Edit Shop`,
    shops_list: 'Shops List',
    add_shop: `Add Shop`,
    set_manager: `Set Manager`,
    time_working: `Working Time`,
    token_tg: `Telegram Token`,
    your_companies: `Your Shops`,
  },
  employees: {
    calculate_wage: `Calculate Wage`,
    self: `Employees`,
  },
  games: {
    leaderboard: {
      balance: `Balance`,
      referral: `Referral`,
    },
  },
  qs: {
    One_company: `One Company`,
    One_service: `One Service`,
    One_staff: `One Staff`,
    at_least: `At least`,
    first_add: `First Add`,
    name_desc_adr: `Name, Description, Address`,
    name_price_duration: `Name, Price, Duration`,
    namestaff_specialization: `Name, Staff, Specialization`,
    open_recording_set_time: `Open Recording, Set Time`,
    set_staff_schedule: `Set Staff Schedule`,
    staff_service: `Staff Service`,
    to_staff: `To Staff`,
  },
  services: {
    self: `Services`,
  },
  system: {
    add: `Add`,
    address: `Address`,
    allowed: `Allowed`,
    are_you_sure_want_to_delete: `Are you sure you want to delete?`,
    contacts: `Contacts`,
    copied: `Copied`,
    create: `Create`,
    delete: `Delete`,
    delete_confirm: `Are you sure you want to delete this course? This action cannot be undone.`,
    description: `Description`,
    edit: `Edit`,
    draft: `Draft`,
    published: `Published`,
    local_view: `Local View`,
    miniapp_view: `Mini App`,
    max_size_of: `Max size of`,
    partners: `Partners`,
    save_changes: `Save Changes`,
    selected: `Selected`,
    view_all: `View All`,
    select_action: "Select Action",
  },
  courses: {
    video_unsupported: 'Unsupported video URL format',
    video_supported_formats: 'Supported formats: YouTube, VK, Rutube, Dzen, Yandex Cloud, Kinescope, plvideo',
    no_forms_found: 'No forms found',
    search_form: 'Search form',
    select_form: 'Select form',
    connect_form: 'Connect Form',
    connect_form_desc: 'Select an existing form to assign as homework.',
    all_forms: 'All',
    quiz_forms: 'Quiz',
    regular_forms: 'Regular',
    reset_form: 'Reset Form',
    selected_form: 'Selected Form',
    unlock_requirement: 'Unlock Requirement (Lesson to open)',
    previous_lesson_required: 'User must complete this lesson first',
    no_prerequisite: 'No prerequisite (Lesson is always open)',
    none: 'None',
    courses_page_title: "Courses",
    tariffs: "Tariffs",
    cohorts: "Cohorts",
    curriculum: "Curriculum",
    settings: "Settings",
    add_tariff: "Add Tariff",
    add_cohort: "Add Cohort",
    tariff_name: "Tariff Name",
    tariff_price: "Price",
    access_duration: "Access Duration",
    access_type: "Access Type",
    duration: "Duration",
    fixed_dates: "Fixed Dates",
    months: "months",
    days: "days",
    hours: "hours",
    years: "years",
    forever: "Forever",
    start_date: "Start Date",
    end_date: "End Date",
    sales_start: "Sales Start",
    sales_end: "Sales End",
    flow_dates: "Flow Dates",
    sales_window: "Sales Window",
    sales_window_hint: "If empty — defaults to flow dates",
    date_range: "Date Range",
    cohort_name: "Cohort Name",
    modules_access: "Modules Access",
    all_modules: "All Modules",
    save_tariff: "Save Tariff",
    save_cohort: "Save Cohort",
    delete_tariff: "Delete Tariff",
    delete_cohort: "Delete Cohort",
    tariff_prices_for_cohort: "Tariff Prices for Cohort",
    copy_tariffs_from_template: "Copy Tariffs from Template",
    configure_tariffs: "Configure Tariffs",
    base_price: "Base Price",
    title_required: "Title is required",
    desc_required: "Description is required",
    price_positive: "Price must be positive",
    close: "Close",
    basic_info: "Basic Info",
    course_title: "Course Title",
    description: "Description",
    cover_image: "Cover Image",
    image_placeholder: "Image Placeholder",
    category: "Category",
    published: "Published",
    pricing: "Pricing",
    create_course: "Create Course",
    save_changes: "Save Changes",
    lessons: "Lessons",
    lesson_title: "Lesson Title",
    module_title: "Module Title",
    add_lesson: "Add Lesson",
    add_module: "Add Module",
    new_course: "New Course",
    create_new_course: "Create New Course",
    edit_course: "Edit Course",
    search_course: "Search Course...",
    preview: "Preview",
    students: "students",
    access_opens: "Access Opens",
    access_closes: "Access Closes",
    immediately: "Immediately",
    specific_date: "Specific Date",
    days_after_payment: "Days after payment",
    never: "Never",
    days_after_opening: "Days after opening",
    days_label: "days",
    // Lesson Editor
    video_content: "Video Content",
    video_url: "Video URL (YouTube / Yandex Video / Kinescope)",
    upload_video: "Upload Video",
    lesson_content: "LESSON CONTENT",
    quiz_tasks: "QUIZ / TASKS",
    discussions: "DISCUSSIONS",
    transcript_notes: "Transcript & Notes",
    transcript: "Transcript",
    attached_files: "Attached Files",
    add_file: "Add File",
    quiz_coming_soon: "Quiz Editor Component Coming Soon",
    loading: "Loading...",
    timecodes: "Timecodes",
    conspectus: "Conspectus",
    // Completion Settings
    completion_requirement: "Completion Requirement",
    free_access: "Free Access",
    free_access_desc: "Student can proceed immediately.",
    timer: "Timer",
    timer_desc: "Student must wait for a specified time.",
    assignment: "Assignment",
    assignment_desc: "Student must submit text or file.",
    quiz: "Quiz",
    quiz_desc: "Student must pass a test.",
    wait_duration: "Wait Duration",
    seconds: "seconds",
    allow_skip: "Allow Student to Skip (Timer is optional)",
    required_submissions: "Required Submissions",
    text_answer: "Text Answer",
    file_attachment: "File Attachment",
    quiz_builder: "Quiz Builder",
    quiz_builder_desc: "Configure questions, answers, and passing scores.",
    open_quiz_builder: "Open Quiz Builder",
    // Test Builder
    min_passing_score: "Minimum Passing Score (%)",
    questions: "Questions",
    add_question: "Add Question",
    question_text: "Question Text",
    question_type: "Question Type",
    single_choice: "Single Choice",
    multiple_choice: "Multiple Choice",
    options: "Options",
    is_correct_answer: "Is Correct Answer?",
    add_option: "Add Option",
    option_placeholder: "Option",
    // Types
    type_single: "Single Choice",
    type_multiselect: "Multiple Choice",
    type_true_false: "True / False",
    type_fill_blank: "Fill in the Blank",
    type_ordering: "Ordering",
    type_matching: "Matching",
    type_image_hotspot: "Image Hotspot",
    // Type specific
    correct_answer_text: "Correct Answer Text",
    pairs: "Pairs",
    left_side: "Left Side",
    right_side: "Right Side",
    add_pair: "Add Pair",
    upload_image_for_hotspot: "Upload Image",
    hotspot_coordinates: "Coordinates (x, y)",
    click_to_set_hotspot: "Click image to set point",
    // Test Player
    quiz_start_title: "Quiz",
    quiz_start_desc: "Check your knowledge on the lesson topic.",
    begin: "Begin",
    result: "Result",
    correct: "Correct",
    retry: "Retry",
    next_lesson: "Next Lesson",
    continue: "Continue",
    great_job: "Great Job!",
    dont_give_up: "Don't Give Up!",
    passed_message: "You have successfully completed this lesson.",
    failed_message: "Study more next time and try again!",
    of: "of",
    // Deadline
    deadline: "Deadline",
    deadline_type: "Deadline Type",
    no_deadline: "No Deadline",
    relative_deadline: "Relative (after opening)",
    fixed_deadline: "Fixed Date",
    deadline_days: "Days",
    deadline_hours: "Hours",
    deadline_date: "Deadline Date",
    unit: "Unit",
    minutes: "Minutes",
    // AI Generation
    generate_ai: "Generate with AI",
    generate_ai_title: "Generate Quiz with AI",
    generate_ai_desc: "Describe the quiz topic, and AI will create questions for you.",
    topic_label: "Quiz Topic or Material Text",
    topic_placeholder: "E.g., JavaScript Basics, Variables and Data Types...",
    generating: "Generating...",
    assignment_description: "Assignment Description",
    check: "Check",
    correct_answer: "Correct!",
    wrong_answer: "Wrong",
    correct_is: "Correct answer",
    next_question: "Next Question",
    finish: "Finish",
    settings_title: "Quiz Settings",
    attempts_label: "Attempts Allowed",
    show_correct_label: "Show Correct Answer on Error",
    time_limit_label: "Time per Question (sec)",
    time_limit_hint: "0 = unlimited",
    time_left: "Time Left",
    design: "Design",
    design_appearance: "Student Cabinet Appearance",
    theme_mode: "Theme Mode",
    primary_color: "Primary Color",
    border_radius: "Border Radius",
    custom_colors: "Custom Colors",
    no_lessons_yet: "No lessons in this module yet",
    video_placeholder_desc: "Paste a YouTube, Yandex Video, or Kinescope video URL",
  },
  access: {
    page_access: "Page Access",
    select_products_desc: "Select products that must be purchased by the user and the interval in days for access to open",
    select_products: "Select Products",
    products: "Products",
    access_opens_after: "Access opens after purchase",
    days_short: "days",
    access_points_price: "Access for points",
    priority: "Priority in list"
  },
  characteristics: {
    title: "Characteristics",
    name: "Characteristic Name",
    type: "Characteristic Type",
    string: "String",
    number: "Number",
    add_characteristic: "Add Characteristic",
    add_value: "Add Value",
    edit_value: "Edit Characteristic Value",
    add_value_title: "Add Value to Characteristic",
    delete_confirm_title: "Delete Characteristic",
    delete_confirm_content: "Are you sure you want to delete value {{value}} for characteristic '{{title}}'?",
    save: "Save",
    cancel: "Cancel",
    characteristic: "Characteristic",
    value: "Value"
  },
  notify: {
    image_upload: "Image Upload",
    button_text: "Button Text",
    button_link: "Button Link",
    add: "Add"
  }
};

export default en;
